export enum CardModificationType {
  NoteAdded = 'NoteAdded',
  NoteRemoved = 'NoteRemoved',
  NoteUpdated = 'NoteUpdated',
  ItemAdded = 'ItemAdded',
  ItemRemoved = 'ItemRemoved',
  ItemUpdated = 'ItemUpdated',
  AttachmentAdded = 'AttachmentAdded',
  AttachmentRemoved = 'AttachmentRemoved',
}
